import React, { memo } from 'react'
import { TranscriptionLineSkeleton } from './transcriptionLineSkekeleton'

const _TranscriptionSkeleton = () => (
  <div>
    <TranscriptionLineSkeleton lineWidth={'80%'} />
    <TranscriptionLineSkeleton lineWidth={'100%'} />
    <TranscriptionLineSkeleton lineWidth={'60%'} />
    <TranscriptionLineSkeleton lineWidth={'70%'} />
    <TranscriptionLineSkeleton lineWidth={'55%'} />
  </div>
)

export const TranscriptionSkeleton = memo(_TranscriptionSkeleton)
